import React, {useContext, useEffect, useState} from "react";
//import { ProfileContext } from "../ProfileContext";
import { errorMesg } from "../../../Toaster";
import { Modal, Button } from 'react-bootstrap';
import {getStagesAPI, getDispositionAPI, getSubDispositionAPI, AddRemarksAPI, getRemarksAPI} from "./../../../../API/Sales/LeadAPI";
import moment from "moment";

const Remarks = ({profiledata, pipelineReloadStatus, profileid, onReload}) =>{

    //const {profiledata, profileid, reloadPipeline} = useContext(ProfileContext);
    const [isremarksaddmodal, setIsRemarksAddModal] = useState(false);
    const [remarkslist, setRemarksList] = useState([]);
    const [stagelist, setStageList] = useState([]);
    const [dispositionlist, setDispositionList] = useState([]);
    const [subdispositionlist, setSubdispositionList] = useState([]);
    const [txtstage, setTxtStage] = useState("");
    const [txtdisposition, setTxtDisposition] = useState("");
    const [txtsubdisposition, setTxtSubdisposition] = useState("");
    const [scheduledate, setTxtScheduleDate] = useState("");
    const [scheduletime, setTxtScheduleTime] = useState("");
    const [txtremarks, setTxtRemarks] = useState("");
    const [btnrsubmitspin, setBtnRSubmitSpin] = useState(false);
    const [isremarksreload, setIsRemarksReload] = useState(false);

    const [formerror, setFormError] = useState({});

    const txtremarksmodalheader = "Add New Remarks";

    useEffect(()=>{
        setRemarksList(profiledata || []);
    }, [profiledata]);

    useEffect(()=>{
        getStagesAPI(setStageList);
    }, []);


    const handleRemarksAddModal = () =>{
		setIsRemarksAddModal(!isremarksaddmodal);
	}

    const handleRemarksModalHide = () =>{
        setIsRemarksAddModal(false);
    }

    const handleSelectStage = (e) =>{
        setTxtStage(e.target.value);

        getDispositionAPI(e.target.value, setDispositionList);
    }

    const handleSelectDisposition = (e) =>{
        setTxtDisposition(e.target.value);

        getSubDispositionAPI(e.target.value, setSubdispositionList);
    }

    const handleSelectSubDisposition = (e) =>{
        setTxtSubdisposition(e.target.value);
    }

    const handleScheduleDate = (e) =>{
        setTxtScheduleDate(e.target.value);
    }

    const handleScheduleTime = (e) =>{
        setTxtScheduleTime(e.target.value);
    }

    const handleRemarks = (e) =>{
        let value = e.target.value;

        value = value.replace(/\s+/g, ' ');

        setTxtRemarks(value);
    }

    const resetRemarksForm = () =>{

        setTxtStage("");
        setTxtDisposition("");
        setTxtSubdisposition("");
        setTxtScheduleDate("");
        setTxtScheduleTime("");
        setTxtRemarks("");
    }

    const validateForm = () => {
        let errors = {};

        if (!txtstage) {
            errors.errorstage = true;
        }

        if (!txtdisposition) {
            errors.errordisposition = true;
        }

        if (!txtsubdisposition) {
            errors.errorreason = true;
        }

        // Stage condition (IMPORTANT FIX)
        const stage = Number(txtstage);

        if (stage !== 4 && stage !== 5) {
            if (!scheduledate) {
                errors.errorscheduledate = true;
            }

            if (!scheduletime) {
                errors.errorscheduletime = true;
            }
        }

        // Remarks
        if (!txtremarks || txtremarks.length <= 15)
        {
            errors.errorremarks = true;
        }

        return errors;
    };

    const handleAddRemarks = (e) =>{

        e.preventDefault();

        const errors = validateForm();

        setFormError(errors);

        const hasError = Object.keys(errors).length > 0;

        if (hasError)
        {
            console.log("Form mein error hai");
            return;
        }
        else
        {
            const formdata = new FormData();
            formdata.append('leadid', profileid);
            formdata.append('stageid', txtstage);
            formdata.append('dispositionid', txtdisposition);
            formdata.append('subdispositioniid', txtsubdisposition);
            formdata.append('notifydate', scheduledate);
            formdata.append('notifytime', scheduletime);
            formdata.append('txtremark', txtremarks);

            AddRemarksAPI(formdata, setBtnRSubmitSpin, setIsRemarksAddModal, () => setIsRemarksReload(prev => !prev), resetRemarksForm, onReload);
        }
    }

    if(!profiledata)
        return null;

    return(
    <div className="card crm-remarks-card h-100 w-100">
        <div class="card-body">
            <div class="title d-flex flex-wrap align-items-center justify-content-between mb-3">
                <div class="left">
                    <h6 class="text-medium mb-30">Latest Remarks</h6>
                </div>
                <div class="right">
                    <button className="btn btn-success" onClick={handleRemarksAddModal}>
                        <i className="fas fa-plus me-1"></i> Add Remarks
                    </button>
                </div>
            </div>

            <div class="crm-remarks-scroll">
                {remarkslist && remarkslist.length === 0 ?
                    <div class="crm-no-remarks" id="noRemarks">
                        <div class="crm-no-remarks-inner">
                            <i class="ti ti-notes-off"></i>
                            <p>No remarks found</p>
                        </div>
                    </div>
                :
                <ul class="timeline-3 crm-remarks-list">
                    {remarkslist && remarkslist.map(remark =>
                        (
                        <li class="crm-remark-item" key={remark.id}>
                            <div class="crm-remark-head">
                                <div>
                                    <span class="remark-heading">{remark.callername}</span>
                                    <span class="crm-remark-meta">Telecaller</span>
                                </div>
                                <span class="remark-date">
                                    {remark.created_at !== "" && remark.created_at !== null &&
                                        (moment(remark.created_at).format('DD MMM YYYY hh:mm'))
                                    }
                                </span>
                            </div>
                            <div class="crm-remark-grid">
                                <div>
                                    <span class="crm-label">Stage:</span>
                                    <span>{remark.stagename}</span>
                                </div>
                                <div>
                                    <span class="crm-label">Disposition:</span>
                                    <span>{remark.dispositionname}</span>
                                </div>
                                <div>
                                    <span class="crm-label">Reason:</span>
                                    <span>{remark.reasontext}</span>
                                </div>
                            </div>

                            <p class="crm-remark-text">{remark.remarks}</p>
                        </li>
                        ))
                    }
                </ul>
                }
            </div>
        </div>

        <Modal show={isremarksaddmodal} onHide={handleRemarksModalHide} centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">{txtremarksmodalheader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <label className="form-label">Lead Stage</label>
                    <select className={`form-control ${formerror.errorstage ? 'input-error' : ''}`} name="stages" id="stages" value={txtstage} onChange={handleSelectStage}>
                        <option value="">Select</option>
                        {stagelist && stagelist.length > 0 ?
                            (stagelist.map(stage =>
                                (
                                    <option value={stage.id} key={stage.id}>{stage.label}</option>
                                )
                            )

                            )
                        :
                            <></>    
                        }
                        
                    </select>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Disposition</label>
                            <select className={`form-control ${formerror.errordisposition ? 'input-error' : ''}`} name="disposition" id="disposition" value={txtdisposition} onChange={handleSelectDisposition}>
                                <option value="">Select</option>
                                {dispositionlist && dispositionlist.length > 0 ?
                                    (dispositionlist.map(disposition =>
                                        (
                                            <option value={disposition.id} key={disposition.id}>{disposition.label}</option>
                                        )
                                    )

                                    )
                                :
                                    <></>    
                                }
                                
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Reason</label>
                            <select className={`form-control ${formerror.errorreason ? 'input-error' : ''}`} name="subdisposition" id="subdisposition" value={txtsubdisposition} onChange={handleSelectSubDisposition}>
                                <option value="">Select</option>
                                {subdispositionlist && subdispositionlist.length > 0 ?
                                    (subdispositionlist.map(subdisp =>
                                        (
                                            <option value={subdisp.id} key={subdisp.id}>{subdisp.label}</option>
                                        )
                                    )

                                    )
                                :
                                    <></>    
                                }
                                
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Schedule Date</label>
                            <input type="date" className={`form-control ${formerror.errorscheduledate ? 'input-error' : ''}`} name="scheduledate" id="scheduledate" value={scheduledate} onChange={handleScheduleDate} />
                        </div>
                    </div>                            
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Schedule Time</label>
                            <input type="time" className={`form-control ${formerror.errorscheduletime ? 'input-error' : ''}`} name="scheduletime" id="scheduletime" value={scheduletime} onChange={handleScheduleTime} />
                        </div>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea className={`form-control ${formerror.errorremarks ? 'input-error' : ''}`} name="remarks" id="remarks" cols="50" rows="5" onChange={handleRemarks}>{txtremarks}</textarea>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleRemarksModalHide}>Close</button>

                {btnrsubmitspin ?
                    <button type="button" class="btn btn-primary"> 
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </button>
                :
                    <button type="button" class="btn btn-primary" onClick={handleAddRemarks}> Add Remarks </button>
                }
            </Modal.Footer>
        </Modal>
    </div>
    );
}

export default Remarks;
